import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from 'src/app/services/layout.service';
import { ISubmenuComponent } from 'src/app/services/menu/menu.models';
import { LazyLoaderBaseComponent } from '../lazy-loader/lazy-loader.component';
import { LazyLoaderService } from '../lazy-loader/lazy-loader.service';

@Component({
    /* tslint:disable:component-selector */
    selector: '[app-submenu]',
    /* tslint:enable:component-selector */
    templateUrl: './app.submenu.component.html',
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                height: '*',
                'z-index': 100
            })),
            state('hidden', style({
                height: '0px',
                'z-index': '*'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppSubMenuComponent extends LazyLoaderBaseComponent implements ISubmenuComponent{

    @Input() item: MenuItem;

    @Input() root: boolean;

    @Input() visible: boolean;

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && (this.layoutService.currentLayout$.value.service.isHorizontalMenu || this.layoutService.currentLayout$.value.service.isSlimMenu)) {
            this.activeIndex = null;
        }
    }

    @Input() get parentActive(): boolean {
        return this._parentActive;
    }

    set parentActive(val: boolean) {
        this._parentActive = val;

        if (!this._parentActive) {
            this.activeIndex = null;
        }
    }

    _reset: boolean;

    _parentActive: boolean;

    activeIndex: number;

    currentLayout$ = this.layoutService.currentLayout$.asObservable();

    constructor(
        public layoutService: LayoutService,
        lazyLoaderService: LazyLoaderService
    ) {
        super(lazyLoaderService)
    }

    itemClick(event: Event, item: MenuItem, index: number) {
        if (this.root) {
            this.layoutService.currentLayout$.value.menuHoverActive = !this.layoutService.currentLayout$.value.menuHoverActive;
        }

        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        // activate current item and deactivate active sibling if any
        this.activeIndex = (this.activeIndex === index) ? null : index;

        // execute command
        if (item.command) {
            item.command({ originalEvent: event, item });
        }

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            setTimeout(() => {
                this.layoutService.currentLayout$.value.layoutMenuScrollerViewChild.moveBar();
            }, 450);
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
            if (this.layoutService.currentLayout$.value.service.isHorizontalMenu || this.layoutService.currentLayout$.value.service.isSlimMenu) {
                this.layoutService.currentLayout$.value.resetMenu = true;
            } else {
                this.layoutService.currentLayout$.value.resetMenu = false;
            }

            this.layoutService.currentLayout$.value.overlayMenuActive = false;
            this.layoutService.currentLayout$.value.staticMenuMobileActive = false;
            this.layoutService.currentLayout$.value.menuHoverActive = !this.layoutService.currentLayout$.value.menuHoverActive;
        }
    }

    onMouseEnter(index: number) {
        if (this.root && this.layoutService.currentLayout$.value.menuHoverActive && (this.layoutService.currentLayout$.value.service.isHorizontalMenu || this.layoutService.currentLayout$.value.service.isHorizontalMenu.isSlimMenu)
            && !this.layoutService.currentLayout$.value.isMobile() && !this.layoutService.currentLayout$.value.isTablet()) {
            this.activeIndex = index;
        }
    }

    async isActive(index: number): Promise<boolean> {
        return await Promise.resolve(this.activeIndex === index);
    }

}

